import React, { createContext } from 'react';
import useAuth from './Hooks/useAuth';

const Context = createContext();

const AuthProvider = ({ children }) => {
  const {
    showLoader,
    handleLogin,
    handleLogout,
    userData,
    setUserData,
    loginWithToken,
  } = useAuth();

  return (
    <Context.Provider
      value={{
        showLoader,
        handleLogin,
        handleLogout,
        userData,
        setUserData,
        loginWithToken,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export { Context, AuthProvider };
